import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const { login, authMode, loading } = useAuth();

  useEffect(() => {
    // If Auth0 is configured, automatically trigger the login flow
    if (authMode === 'auth0' && !loading) {
      login('', ''); // Empty params for Auth0
    }
  }, [authMode, loading, login]);

  // Show loading while Auth0 redirects
  if (authMode === 'auth0') {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #22c55e 0%, #06b6d4 100%)',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <Typography variant="h6">Redirecting to secure login...</Typography>
        </Paper>
      </Box>
    );
  }

  // Fallback for when Auth0 is not configured
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #22c55e 0%, #06b6d4 100%)',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box textAlign="center" mb={4}>
            <Typography variant="h2" sx={{ fontSize: '3rem', mb: 1 }}>
              🌱
            </Typography>
            <Typography variant="h4" gutterBottom fontWeight="bold">
              Welcome Back!
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={3}>
              Continue your gardening journey
            </Typography>
          </Box>

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => login('', '')}
            sx={{ mb: 2 }}
          >
            Sign In with Auth0
          </Button>

          <Box textAlign="center">
            <Typography variant="body2">
              New to Botala?{' '}
              <Link to="/register" style={{ color: '#22c55e' }}>
                Create an account
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login;